import { CouponError, CreateCouponInput } from "modules/cupon/store/actionType";


export const validateCouponForm = (data: CreateCouponInput): CouponError => {
  const errors: CouponError = {};

  if (!data.membershipDurationID.trim()) {
    errors.membershipDurationID = "Membership Duration is required";
  }

  if (!data.generationType.trim()) {
    errors.generationType = "Generation type is required";
  }

  if (data.generationType === "admin") {
    if (!data.receiverDetail?.trim()) {
      errors.receiverDetail = "Receiver detail is required for admin type";
    } 
  } else {
    if (data.count === 0 || data.count === null) {
  errors.count = "Count is required";
} else if (data.count <= 0) {
  errors.count = "Count must be greater than 0";
}

  }

  return errors;
};

export default validateCouponForm;
